export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14763.2c6a2b88.jpg";